import { render, staticRenderFns } from "./YingEnshengwuBaseFloatingPC.vue?vue&type=template&id=65b3a760"
import script from "./YingEnshengwuBaseFloatingPC.vue?vue&type=script&setup=true&lang=js"
export * from "./YingEnshengwuBaseFloatingPC.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports